const func = $target => {

    console.log('business edit loaded');

    // if($businessEditModal[0]) {

        $target.modal();
    // }

};

export default func;